export const SHARE_APP_HOST = "sorakan.jspmix.com";

export function extractShareDate(headerText: string): string {
  const normalized = headerText.replace(/\s+/g, " ").trim();
  if (!normalized) return "";
  const separator = normalized.lastIndexOf("・");
  return (separator >= 0 ? normalized.slice(separator + 1) : normalized).trim();
}

export function formatShareDate(dateText: string, showTime: boolean): string {
  const normalized = dateText.replace(/\s+/g, " ").trim();
  if (showTime) return normalized;
  return normalized.split(" ")[0] ?? normalized;
}

function naturalizeSentence(sentence: string): string {
  return sentence
    .replace(/^この写真は[、,\s]*/u, "")
    .replace(/様子を示しています。?$/u, "空でした。")
    .replace(/様子が見えます。?$/u, "空でした。")
    .replace(/形成されています/g, "できています")
    .replace(/形成されている/g, "できている")
    .replace(/になっており/g, "になっていて")
    .replace(/しており/g, "していて")
    .replace(/と考えられます。?$/u, "かもしれません。")
    .replace(/とみられます。?$/u, "みたいです。")
    .replace(/と見られます。?$/u, "みたいです。")
    .replace(/広がっています。?$/u, "広がっていました。")
    .replace(/なっています。?$/u, "なっていました。")
    .trim();
}

export function buildShareMicrocopy(easySummary: string): string {
  const cleaned = easySummary.replace(/\s+/g, " ").trim();
  if (!cleaned) return "今日の空を、少しだけ立ち止まって見上げてみました。";

  const sentences = cleaned.match(/[^。！？]+[。！？]+/g)?.map((part) => part.trim()).filter(Boolean) ?? [cleaned];
  const natural = sentences.slice(0, 3).map(naturalizeSentence).filter(Boolean);
  const text = natural.join("");
  return text || "今日の空を、少しだけ立ち止まって見上げてみました。";
}
